import BaseController from "./controller-base";

interface ControllerConstructor<T extends BaseController> {
    new(element: HTMLElement, data: any): T;
}
class ControllerRegistry {
    private controllers: Record<string, ControllerConstructor<BaseController>> = {};

    register<T extends BaseController>(name: string, controller: ControllerConstructor<T>) {
        this.controllers[name] = controller;
    }

    get<T extends BaseController>(name: string): ControllerConstructor<T> | undefined {
        return this.controllers[name] as ControllerConstructor<T> | undefined;
    }

    createInstance<T extends BaseController>(name: string, element: HTMLElement, data: any): T {
        const ControllerClass = this.get<T>(name);
        if (!ControllerClass) {
            throw new Error(`Controller not found: ${name}`);
        }
        return new ControllerClass(element, data);
    }
}

const controllerRegistry = new ControllerRegistry();
export default controllerRegistry;